// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as FacilityMap$LumiDocuments from "lumi-documents/lib/es6/src/FacilityMap.res.js";

function fromShape(shape) {
  let points = FacilityMap$LumiDocuments.Shape.toPoints(shape);
  let shifted = Stdlib_Option.getOr(Stdlib_Option.map(points[0], first => points.slice(1).concat([first])), []);
  let placePixelWidth = Math.min(...Belt_Array.zipBy(points, shifted, V2f$Linear.minus).map(V2f$Linear.length));
  return placePixelWidth / 0.4;
}

function fixedInScreenSpace(scale, mapTransform, relMinOpt, relMaxOpt) {
  let relMin = relMinOpt !== undefined ? relMinOpt : [
      0.9,
      0.9
    ];
  let relMax = relMaxOpt !== undefined ? relMaxOpt : [
      1.5,
      1.5
    ];
  let scaleVec = V2$Linear.fill(scale);
  let transformScale = Transform$Linear.M23f.toSimpleTransform(mapTransform).scale;
  let unscaled = Transform$Linear.M23f.scale(V2f$Linear.recip(transformScale));
  let newScale = Transform$Linear.M23f.apply(scaleVec, unscaled);
  let relFixedScale = V2f$Linear.divide(newScale, scaleVec);
  let clampedRelScale = V2$Linear.zipWith((prim0, prim1) => Math.max(prim0, prim1), relMin, V2$Linear.zipWith((prim0, prim1) => Math.min(prim0, prim1), relMax, relFixedScale));
  return V2$Linear.x(V2f$Linear.multiply(scaleVec, clampedRelScale));
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

let $$default = 15;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  $$default as default,
  fromShape,
  fixedInScreenSpace,
}
/* V2f-Linear Not a pure module */
